import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SignalEvent, SignalRChannel } from '../models/signlaR.model';

@Injectable()
export abstract class SignalRService {
  // To initialize the conexion with endpoint and type
  abstract initializeSignalR(filterValues: SignalRChannel): void;
  // To subscribe the event
  abstract getDataStream<TDataShape>(filterValues: SignalRChannel): Observable<SignalEvent<TDataShape>>
  // To stop conexion
  abstract stopConnection(filterValues: SignalRChannel): void;
  // To subscribe the error event
  abstract getConnectionErrors(filterValues: SignalRChannel): Observable<boolean>;
}